import { ArrowRight, Map } from 'lucide-react';
import { Link } from 'react-router-dom';

export default function Hero({ betaMode, onOpenAuth }) {
  return (
    <section className="landing-hero" aria-labelledby="landing-title">
      <div className="landing-hero-glow" aria-hidden="true" />
      <div className="landing-wrap landing-hero-inner">
        {betaMode && <p className="landing-eyebrow"><span className="landing-status-dot" />Открытое бета-тестирование · присоединяйтесь первыми</p>}
        <h1 id="landing-title">Оценка природных <span>катастрофических рисков</span> на карте России</h1>
        <p className="landing-lead">CatRUS — геоинформационная система, которая оценивает подверженность любой точки России 13 природным опасностям: от землетрясений и наводнений до оползней и лесных пожаров.</p>
        <div className="landing-actions">
          <button className="landing-button landing-button-primary landing-button-large" onClick={() => onOpenAuth('register')}>{betaMode ? 'Присоединиться к тестированию' : 'Зарегистрироваться'} <ArrowRight size={17} /></button>
          <Link className="landing-button landing-button-outline landing-button-large" to="/map"><Map size={17} />Открыть карту</Link>
        </div>
        {betaMode && <p className="landing-note">Система в стадии активной разработки. Станьте одним из первых пользователей и помогите сформировать продукт.</p>}
      </div>
    </section>
  );
}
